import { Check } from "lucide-react";

const benefits = [
  "Stronger managers and leadership teams",
  "Better execution of strategy",
  "Improved productivity and operational efficiency",
  "Stronger customer acquisition and retention",
  "Greater regulatory and operational agility",
  "Better digital readiness and adoption",
  "Training solutions aligned with real organisational goals",
];

export default function Benefits() {
  return (
    <section
      data-testid="benefits-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <span className="eyebrow">Why Partner With Us</span>
            <h2
              data-testid="benefits-headline"
              className="font-display mt-4 text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-slate-900"
            >
              Why organisations partner with{" "}
              <span className="text-orange-600">Ascentix</span>.
            </h2>
            <p className="mt-5 text-[17px] leading-relaxed text-slate-600 max-w-[460px]">
              We don't sell off-the-shelf training. We co-create development
              experiences that move the needle on the metrics your leadership
              team cares about.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-4 md:gap-5">
              {benefits.map((b, i) => (
                <li
                  key={i}
                  data-testid={`benefit-item-${i}`}
                  className="reveal rounded-2xl border border-slate-900/5 bg-white p-5 md:p-6 flex items-start gap-4"
                  style={{ transitionDelay: `${i * 50}ms` }}
                >
                  <div className="shrink-0 mt-0.5 size-9 rounded-xl bg-orange-50 border border-orange-100 text-orange-600 flex items-center justify-center">
                    <Check className="size-5" strokeWidth={2.4} />
                  </div>
                  <p className="text-[15px] md:text-[16px] leading-relaxed text-slate-800 font-medium">
                    {b}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
